
<!--将选择的所有的结论放到这个组件-->
<template>
    <div class="input-item">
        <div class="top">
            <span class="required" v-if="required">*</span>
            <div class="title" v-html="title"></div>
        </div>
        <div id="verdict">
            <div class="verdict-li" v-for="verdict in value">{{ verdict }}</div>
            <template v-if="!isDetails">
                <div @click="getVerdict" class="build-verdict">点击生成</div>
                <span class="build-verdict-tip">您的访视结论，如有修改请再次点击</span>
            </template>
        </div>
        <div  class="title" style="margin-bottom: 10px" v-html="subTitle"></div>
        <InputOption :isDetails="isDetails" v-model="input.value" v-bind="input.props"/>
    </div>
</template>
<script>
    import InputOption from '../DoTopic/Private/InputOption.vue'
    export default {
        name: 'InputItem',
        props: {
            value:Array,
            title:String,
            subTitle:String,
            required:Boolean,
            input:Object,
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            getVerdict(){
                let verdictDom = document.querySelectorAll('[data-is-verdict="true"]');
                let selectVerdict = [];
                verdictDom.forEach(option=>{
                    let isSelect = option.classList.contains('active') == true;
                    if(!isSelect){ return }
                    let verdict = option.querySelector('.option-name').innerText;
                    selectVerdict.push(verdict)
                });

                this.$emit('input',selectVerdict)
            }
        },
        mounted() {
            // //将所有选中的结论回写到这个组件里
            // //当组件出现的时候再去获取吧。
            // setTimeout(_=>{
            //
            // },600)
        },
        components:{InputOption}
    }
</script>
<style lang="scss" scoped>
    .input-item{
        padding: 16px;
        #verdict{
            margin-bottom: 10px;
            .build-verdict{
                width: 100%;
                height: 40px;
                color: #ff0000;
                font-size:15px;
                display: flex;
                margin-top: 10px;
                justify-content: center;
                align-items: center;
                background-color: #FFF0F0;
            }
            .build-verdict-tip{
                color: #999;
                display: block;
                font-size:12px;
                margin-top: 10px;
                text-align: center;
            }
            .verdict-li{
                color: #999;
                &:before{
                    content: '';
                    display: inline-block;
                    margin-right: 6px;
                    width: 12px;
                    height: 12px;
                    background: #FFA307;
                }
            }
        }
        .top{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                font-size: 16px;
            }
        }
    }

</style>
